<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    width="800px"
    :inheritAttrs="false"
    :append-to-body="true">
    <div class="upload-content">
      <el-upload
        class="upload-demo"
        drag
        :data="params"
        :action="uploadUrl"
        :headers="headers"
        :before-upload="beforeUpload"
        :on-success="uploadSuccess"
        :show-file-list="false">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip">支持格式：xls、xlsx</div>
      </el-upload>
    </div>
    <div class="link">
      <el-button type="text" @click="downloadExel">下载批量创建模板表格</el-button>
    </div>
    <div class="preview">
      <p class="info" v-if="currentData.length">共 {{currentData.length}} 条，{{errorList.length}} 条错误数据，创建时将忽略错误数据</p>
      <el-table :data="currentData" v-if="currentData.length" :row-class-name="tableRowClassName">
        <el-table-column type="index" label="序号" fixed></el-table-column>
        <el-table-column width="180px" label="面试日期" prop="queue.beginTime"></el-table-column>
        <el-table-column width="150px" label="公司名称" prop="queue.companyName"></el-table-column>
        <el-table-column width="150px" label="职位名称" prop="queue.positionName"></el-table-column>
        <el-table-column width="100px" label="是否录制" prop="queue.hasRecord" :formatter="hasRecordFormat"></el-table-column>
        <el-table-column width="100px" label="角色" prop="member.role" :formatter="roleFormat"></el-table-column>
        <el-table-column width="100px" label="面试官组号" prop="member.number"></el-table-column>
        <el-table-column width="100px" label="姓名" prop="member.showName"></el-table-column>
        <el-table-column width="100px" label="手机号" prop="member.phone"></el-table-column>
        <el-table-column width="150px" label="邮箱" prop="member.email"></el-table-column>
        <el-table-column width="150px" label="简历地址" prop="member.attachmentUrl"></el-table-column>
        <el-table-column width="100px" label="批次" prop="member.beginTime"></el-table-column>
        <el-table-column width="150px" label="一面面试官组号" prop="member.blackTargetNumberList"></el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <el-button type="cancel" size="small" @click="cancel">取消</el-button>
      <el-button type="primary" size="small" :loading="loading" @click="multiCreateQueue">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import toolkit from "@/util/toolkit"
import axios from "axios"
export default {
  data(){
    return{
      params: {
        ucCompanyId: toolkit.getCompany()
      },
      headers: {
        AUTHORIZATION: `Bearer ${toolkit.getToken()}`
      },
      loading: false,
      currentData: [],
      createParamsList: [],
      fileUrl: '',
      uploadMessage: '文件上传中...',
    }
  },
  computed: {
    uploadUrl(){
      return toolkit.apiPath('/interview/excel/importQueue')
    },
    errorList(){
      return this.currentData.filter(e => e.isOk == 0)
    },
    okList(){
      return this.currentData.filter(e => e.isOk == 1)
    }
  },
  methods: {
    hasRecordFormat(row, column){
      if (row.queue.hasRecord === 0) {
        return '否'
      } else  {
        return '是'
      }
    },

    roleFormat(row, column){
      if (row.member.role === 1) {
        return '面试官'
      } else  {
        return '候选人'
      }
    },

    // 下载相关
    downloadExel(){
      window.open("https://oss.hinapower.cn/cdn/app/interview/file/海纳排队面试批量创建模板.xlsx")
    },

    // 上传相关
    beforeUpload(file){
      let isExcel = false
      let ext = file.name.toLowerCase().split('.')
      const type = ext[ext.length-1];
      if(['xlsx', 'xls', 'zip'].indexOf(type) >= 0){
        isExcel = true;
      }
      if (type === 'zip') {
        const uploadUrl = toolkit.goApiPath('/rc/agent/anonymous/getUploadUrl') + toolkit.uploadParams();
        const message = this.$message({
          message: this.uploadMessage,
          type: 'warning',
          showClose: true,
          duration: 0
        })
        toolkit.post(uploadUrl).then((resp) => {
          if (resp.code !== 0) {
            return Promise.reject(new Error('网络错误:' + resp.message));
          }
          const obj = resp.data.object;
          const url = resp.data.url;
          const a = axios.create();
          return a.request({
            method: 'put',
            url: url,
            data: file,
            headers: { 'Content-Type': '' },
            onUploadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                const percentage =
                    ((progressEvent.loaded / progressEvent.total) * 100) | 0;
                console.log(percentage);
                this.uploadMessage = `文件上传中(${percentage}%)。。。`
                message.$data.message = this.uploadMessage;
              }
            },
          }).then(() => {
            return obj
          })
        })
        .then((obj) => {
          return toolkit.post("/interview/excel/parseQueueInterviewZip", {
            ossObjectName: obj
          })
        }).then(resp => {
          if (+resp.code !== 0) {
            return Promise.reject(new Error('网络错误:' + resp.message));
          }
          this.currentData = resp.data.excelDataList;
          this.createParamsList = resp.data.createParamsList;
          this.fileUrl = resp.data.fileUrl;
        })
        .catch((err) => {
          this.$message.error("" + err);
        })
        .finally(() => {
          message.close();
        });
        return false;
      }
      // 大小限制暂时不需要
      // const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isExcel) {
        this.$message.error("上传文件只能是 xls/xlsx 格式!");
      }
      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 2MB!");
      // }
      return isExcel
    },
    uploadSuccess(e){
      if(e.code == 0){
        this.currentData = e.data.excelDataList
        this.createParamsList = e.data.createParamsList
        this.fileUrl = e.data.fileUrl
      }else{
        this.$message.error(e.message)
      }
    },
    tableRowClassName({row, rowIndex}){
      if(!row.isOk){
        return "error-row"
      }
    },
    multiCreateQueue(){
      if(this.createParamsList && this.createParamsList.length){
        this.loading = true
        toolkit.post("/interview/queueVideo/mCreate", {
          list: this.createParamsList
        }).then(res => {
          if(res.code == 0){
            this.$message.success("创建成功")
            this.cancel()
            this.$emit("chose")
            this.$emit("refresh")
          }else{
            this.$message.error(res.message)
          }
        }).finally(()=>{
          this.loading = false
        })
      }
    },
    cancel(){
      this.currentData = []
      this.createParamsList = []
      this.fileUrl = ""
      this.$emit("chose")
    }
  }
}
</script>
<style lang="scss" scoped>
.footer{
  @include flexBox;
  margin-top: 20px;
}
/deep/.upload-demo{
  width: 100%;
  .el-upload{
    width: 100%;
    .el-upload-dragger{
      width: 100%;
    }
  }
}
>>>.el-table th {
    padding: 20px 0;
}
>>>.el-table td {
    padding: 20px 0;
}
>>>.el-table .cell {
    padding-left: 20px;
}
.preview{
  max-height: 300px;
  overflow: auto;
}
/deep/.el-table .error-row {
  color: $Error;
}
>>>.el-table td, .el-table th.is-leaf,.el-table--border, .el-table--group{
  border-color: #f6f6f6;
}
>>>.el-table--border::after, .el-table--group::after, .el-table::before{
  background-color: #f6f6f6;
}
</style>



// WEBPACK FOOTER //
// src/components/MultiCreateQueueInterview.vue